// extracted by mini-css-extract-plugin
module.exports = {"body":"PayModal_body__3aZxb","header":"PayModal_header__1CuKT","container":"PayModal_container__tcTnT","fail":"PayModal_fail__3ZTLb"};